import React, { memo } from "react";
import { StyledTitle, StyledSlider } from "../ProductDetail.styles";
import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";
import Box from "component/layoutComponents/Box";
import ProductCard from "component/MarketPlace/ProductCard";
import styled from "styled-components";
import DefaultUptimeTheme from "component/theme/defaultTheme";
import { Product } from "component/MarketPlace/ProductCard/types";

const mapProductItem = (product: any) => ({
  pictures: [{ medium: product.productImage }],
  name: product.productName,
  description_text: product.specsData,
  brand: { name: product.modelManufacturer },
  mock: { approval_status: product.approvalRequestStatus },
} as Product);

const StyledArrowForwardIosRounded = styled(ArrowForwardIosRounded)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => ({
    color: `${theme.uptimeColors.generalColors.icon.enabled} !important`,
    boxShadow: "none !important",
  })
);

const StyledArrowBackIosRounded = styled(ArrowBackIosRounded)(
  ({ theme }: { theme: typeof DefaultUptimeTheme }) => ({
    color: `${theme.uptimeColors.generalColors.icon.enabled} !important`,
    boxShadow: "none !important",
  })
);

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: <StyledArrowForwardIosRounded />,
  prevArrow: <StyledArrowBackIosRounded />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CompatibleAccessoriesContent = ({
  compatibleAccessories,
  title,
  locale
}: {
  compatibleAccessories: any[];
  title: string;
  locale?: string;
}) => {
  return (
    <>
      <StyledTitle variant="h3" color="text.primary">{title}</StyledTitle>
      <StyledSlider {...sliderSettings}>
        {compatibleAccessories?.map((product: any) => {
          return (
            <Box>
              <Box m="32px 12px 10px">
                <ProductCard
                  product={mapProductItem({
                    approvalRequestStatus: locale || product.approvalRequestStatus,
                    productImage: product.productImage,
                    productName: product.productName,
                    modelManufacturer: product.modelManufacturer,
                    specsData: product.specsData,
                  })}
                  maxDescLines={2}
                  type="narrow"
                />
              </Box>
            </Box>
          );
        })}
      </StyledSlider>
    </>
  );
};

export default memo(CompatibleAccessoriesContent);
